import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FbShareModule } from '../fb-share/fb-share.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { EndFundraiserBannerComponent } from './components/end-fundraiser-banner/end-fundraiser-banner.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FbShareModule,
    WhatsappShareModule
  ],
  declarations: [EndFundraiserBannerComponent],
  exports: [EndFundraiserBannerComponent],
})
export class EndFundraiserBannerModule { }
